import React, { FC, useContext, useEffect, useState } from "react";
import { Transition } from 'react-transition-group';

import { BoardContext, CardContext, SocketContext, TeamContext, UserContext } from "../../../context";

import { ArrowNotification, PinkNotification, SolutionCard, User } from "../../atoms";
import { IPlayerSolution } from "../../../interfaces";
import { Phase } from "../../../util/enums";
import { useSound } from "../../../hooks";
import { SwapCardButton } from "..";
import { useTranslation } from "react-i18next";

interface PlayersSolutionCardsMoleculeProps {
    selectedCard?: IPlayerSolution;
    cardDimentions?: any;
    proposedCardOrder?: number;
    fullScreenIsOn?: boolean;
}

export const PlayersSolutionCardsMoleculeMemo: FC<PlayersSolutionCardsMoleculeProps> = ({ selectedCard, cardDimentions, proposedCardOrder, fullScreenIsOn }) => {
    const { t } = useTranslation();
    const { 
        theSolutionCardSelectedByDilemmaOwner, 
        dilemmaOwnerPickedASolutionSocketEvent,
        setTheSolutionCardSelectedByDilemmaOwner
    } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const {
        setIsDragging,
        dataOfDoubleClickedSolutionCard,
        setDataOfDoubleClickedSolutionCard
    } = useContext(CardContext);
    const { setAreStrengthsShownFullScreen } = useContext(BoardContext);
    const [proposedCardDimentions, setProposedCardDimentions] = useState(cardDimentions);
    const [isReturnButtonHovered, setIsReturnButtonHovered] = useState<boolean>(false);
    const [isCancelButtonHovered, setIsCancelButtonHovered] = useState<boolean>(false);

    const isTheUserDilemaOwner: boolean = userData?.email === game?.gameInfo.currentPlayerEmail;
    const isThisCardSelectedByDilemmaOwner: boolean = dataOfDoubleClickedSolutionCard?.card?.id === selectedCard?.card?.id;
    const duration = 500;
    const {playSound} = useSound();

    const defaultStyle = {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 1,
    }

    useEffect(() => {
        if (theSolutionCardSelectedByDilemmaOwner)
            playSound("/sounds/MergedYay.mp3");
    
    },[playSound, theSolutionCardSelectedByDilemmaOwner]);
    
    useEffect( () => {
        setProposedCardDimentions(cardDimentions);
    }, [cardDimentions]);

    const TransitionStatus = {
        'entering': { opacity: 0.5 },
        'entered': { opacity: 1 },
        'exiting': { opacity: 1 },
        'exited': { opacity: 1 },
        "unmounted": { opacity: 1 }
    };

    useEffect(() => {
        if (game?.phase === Phase.QUESTION_CARD)
            setIsDragging(false);
    }, [game, setIsDragging]);

    const notificationExangeCard = () => {
        return (
            <div style={{transform: "scale(0.7)", position: "absolute", width: "10px", height: "10px", bottom: "-1vw", right: "-14vw" }}>
                <div className="center_horizontally_and_vertically">

                    <div style={{position: "relative", left: "-17vw" }}>
                        <ArrowNotification text={t("returnTheCardBackToYourHandsText")} type="left" width="18vw" />
                    </div>
                </div>
            </div>
        );
    }

    if (!selectedCard)
        return <div> </div>;

    const checkIfTheUserWhoDoubleClickedIsDilemmaOwner = () => {
        if (game?.phase === Phase.QUESTION_CARD) return; 
        

        if (isTheUserDilemaOwner)
            setDataOfDoubleClickedSolutionCard(selectedCard);
        //RESENJE

        const selectedCardId = selectedCard?.card?.id;
        if (selectedCardId && isTheUserDilemaOwner){
            dilemmaOwnerPickedASolutionSocketEvent(selectedCardId);
            setTheSolutionCardSelectedByDilemmaOwner(selectedCardId)
        }
    }

    const diselectSelectedSolutionCard = () => {
        if(game?.phase === Phase.CHOOSE_SOLUTION){
            setDataOfDoubleClickedSolutionCard(undefined);
            setTheSolutionCardSelectedByDilemmaOwner(undefined);
            setAreStrengthsShownFullScreen(false);
            dilemmaOwnerPickedASolutionSocketEvent();
        }
    }

    return (
        <div className="players_solution" onDoubleClick={() => checkIfTheUserWhoDoubleClickedIsDilemmaOwner()} >
                <Transition in={true} timeout={duration} appear>
                    {state => (
                        <div style={{ ...defaultStyle, ...TransitionStatus[state]}}>
                            <div className="position_absolute" style={proposedCardDimentions}>
                                <div className="players_solution__content_wrapper">
                                    
                                    <div className="players_solution__profile_icon">
                                        <div className="MadeuPhupWopDoop">
                                            <div> <User type="singlePicture" playerData={selectedCard.player}/> </div>
                                        </div>
                                    </div>

                                    <div className="players_solution__card">
                                        <SolutionCard cardData={selectedCard.card} isThisCardSelectedByDilemmaOwner={isThisCardSelectedByDilemmaOwner} cardIndex={proposedCardOrder} fullScreenIsOn={fullScreenIsOn} />
                                    </div>

                                    {dataOfDoubleClickedSolutionCard && 
                                        <div>
                                            <div 
                                                className="solution_card_x_button" 
                                                onClick={() => diselectSelectedSolutionCard() } 
                                                onMouseEnter={() => setIsCancelButtonHovered(true)}
                                                onMouseLeave={() => setIsCancelButtonHovered(false)}
                                            >
                                                {isCancelButtonHovered &&
                                                    <PinkNotification notificationWidthVW={30} notificationRenderingSide="right" text={t("cancelTheActionText")} moveFromTop={10} /> 
                                                }
                                            </div>
                                        </div>
                                    }

                                    {selectedCard.player.email === userData?.email && game?.phase === Phase.QUESTION_CARD && 
                                        <div 
                                            className="return_proposed_card_button"
                                            onMouseEnter={() => setIsReturnButtonHovered(true)}
                                            onMouseLeave={() => setIsReturnButtonHovered(false)}
                                        >
                                            {isReturnButtonHovered && notificationExangeCard()}
                                            <SwapCardButton cardType="solution" />
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    )}
                </Transition>
        </div>
    );
};

const PlayersSolutionCardsMolecule = React.memo( PlayersSolutionCardsMoleculeMemo );

export default PlayersSolutionCardsMolecule;
